import { render, staticRenderFns } from "./ConfirmAllocationsAction.vue?vue&type=template&id=06cfbff3&"
import script from "./ConfirmAllocationsAction.vue?vue&type=script&lang=js&"
export * from "./ConfirmAllocationsAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports